import { useMutation, useQuery } from '@tanstack/react-query';
import { UpsertLocationMutationVariables } from 'src/gql/graphql';
import { graphql } from 'src/gql';
import { graphqlRequest, queryClient } from './_request';

const getLocationsDocument = graphql(/* GraphQL */ `
  query GetLocations {
    getLocations {
      ...LocationFields
      children {
        ...LocationFields
        children {
          ...LocationFields
          children {
            ...LocationFields
            children {
              ...LocationFields
            }
          }
        }
      }
    }
  }

  fragment LocationFields on LocationModel {
    id
    type
    name
    picture
    nameResale
    nameAI
    description
    latitude
    longitude
    annualRevenueIncreasePct
    isFavorite
    createdAt
    updatedAt
  }
`);

const upsertLocationDocument = graphql(/* GraphQL */ `
  mutation UpsertLocation($data: LocationUpsertInput!) {
    upsertLocation(data: $data)
  }
`);

const favoriteLocationDocument = graphql(/* GraphQL */ `
  mutation FavoriteLocation($locationId: String!) {
    favoriteLocation(id: $locationId)
  }
`);

export function useUpsertLocationMutation() {
  return useMutation({
    mutationFn: async (variables: UpsertLocationMutationVariables) =>
      graphqlRequest({ document: upsertLocationDocument, variables }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['locations'] });
    },
  });
}

export function useFavoriteLocationMutation() {
  return useMutation({
    mutationFn: async (locationId: string) =>
      graphqlRequest({
        document: favoriteLocationDocument,
        variables: { locationId },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['locations'] });
    },
  });
}

export function useGetLocationsQuery() {
  return useQuery({
    queryKey: ['locations'],
    staleTime: Infinity,
    queryFn: async () => graphqlRequest({ document: getLocationsDocument }),
  });
}
